import React, { useState, useEffect } from 'react';
import {  useNavigate } from 'react-router-dom';
import '../styles/ProjectList.css';
import botImg from '../img/bot_helper.png';
import Header from './Header';

const ProjectList = ({ user, setUser }) => {
  const navigate = useNavigate();
  const [text, setText] = useState('');
  const fullText = `Вітаю ${user} на платформі Молодого соціального підприємця. 
  Я робот-козак, який допоможе тобі створити твій перший соціальний проєкт за допомогою популярного інструменту Lean Canvas. 
  Він допоможе чітко визначити проблему, запропонувати рішення та сформулювати ціннісну пропозицію для своєї аудиторії. 
  Це дозволяє ефективно планувати та реалізовувати проєкти, орієнтуючись на потреби споживачів та ключові показники успіху.
  Натискай на кнопку меню "Створити проєкт" і ставай соціальним підприємцем!`;


  const typeText = async () => {
    let index = 0;
  let currentText = ''
    while (index < fullText.length) {
      currentText += fullText[index]; // Додаємо наступний символ до поточного тексту
      setText(currentText); 
      index++;
    
      await new Promise(resolve => setTimeout(resolve, 5)); // Чекаємо 50 мс перед наступним символом
    }
  };

  useEffect(() => {
    typeText(); // Запускаємо набір тексту при завантаженні компонента
  }, [fullText]);

  useEffect(() => {
    // Redirect to "/" after logout
   if(!user) navigate('/');
  }, [navigate,user]);


  return   <div className="project-list-page">
      <Header setUser={setUser} user={user} />
      <div className="text-container">
        <img src={botImg} alt="bot-kozak for help young people" />
        <div className="text-frame">
          <p className="animated-text">{text}</p>
        </div>
      </div>
    </div>

}


export default ProjectList;